export const APP_INIT_START = 'APP_INIT_START' as const;
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS' as const;
export const APP_INIT_FAILURE = 'APP_INIT_FAILURE' as const;

export const SET_APP_INIT_DATA = 'SET_APP_INIT_DATA' as const;

export const APP_LOG = 'APP_LOG' as const;
export const LOG_ACTION = 'LOG_ACTION' as const;
export const LOG_APPSFLYER_ACTION = 'LOG_APPSFLYER_ACTION' as const;
export const LOG_PAYMENT_OPEN_APPSFLYER_ACTION = 'LOG_PAYMENT_OPEN_APPSFLYER_ACTION' as const;

export const OPEN_MODAL = 'OPEN_MODAL' as const;
export const CLOSE_MODAL = 'CLOSE_MODAL' as const;

export const USER_UPDATE_START = 'USER_UPDATE_START' as const;
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS' as const;
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE' as const;

export const USER_UPDATE_PASSWORD_START = 'USER_UPDATE_PASSWORD_START' as const;
export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS' as const;
export const USER_UPDATE_PASSWORD_FAILURE = 'USER_UPDATE_PASSWORD_FAILURE' as const;

export const USER_UPDATE_USERNAME_START = 'USER_UPDATE_USERNAME_START' as const;
export const USER_UPDATE_USERNAME_SUCCESS = 'USER_UPDATE_USERNAME_SUCCESS' as const;
export const USER_UPDATE_USERNAME_FAILURE = 'USER_UPDATE_USERNAME_FAILURE' as const;
export const USER_UPDATE_USERNAME_CLEAR = 'USER_UPDATE_USERNAME_CLEAR' as const;

export const USER_PROMOCODE_APPLY_START = 'USER_PROMOCODE_APPLY_START' as const;
export const USER_PROMOCODE_APPLY_SUCCESS = 'USER_PROMOCODE_APPLY_SUCCESS' as const;
export const USER_PROMOCODE_APPLY_FAILURE = 'USER_PROMOCODE_APPLY_FAILURE' as const;

export const USER_PROMOCODE_REMOVE_START = 'USER_PROMOCODE_REMOVE_START' as const;
export const USER_PROMOCODE_REMOVE_SUCCESS = 'USER_PROMOCODE_REMOVE_SUCCESS' as const;
export const USER_PROMOCODE_REMOVE_FAILURE = 'USER_PROMOCODE_REMOVE_FAILURE' as const;

export const SET_IS_FIRST_LOGIN = 'SET_IS_FIRST_LOGIN' as const;

export const COMPLETE_ONBOARDING_START = 'COMPLETE_ONBOARDING_START' as const;
export const COMPLETE_ONBOARDING_SUCCESS = 'COMPLETE_ONBOARDING_SUCCESS' as const;
export const COMPLETE_ONBOARDING_FAILURE = 'COMPLETE_ONBOARDING_FAILURE' as const;

export const RESET_FORM_ERROR = 'RESET_FORM_ERROR' as const;

export const UPDATE_AB_TEST_IS_USED_START = 'UPDATE_AB_TEST_IS_USED_START' as const;
export const ADD_AB_TEST_TO_IS_USED_QUEUE = 'ADD_AB_TEST_TO_IS_USED_QUEUE' as const;

export const LOAD_ACCOUNT_TRADE_INFO_START = 'LOAD_ACCOUNT_TRADE_INFO_START' as const;
export const LOAD_ACCOUNT_TRADE_INFO_SUCCESS = 'LOAD_ACCOUNT_TRADE_INFO_SUCCESS' as const;
export const LOAD_ACCOUNT_TRADE_INFO_FAILURE = 'LOAD_ACCOUNT_TRADE_INFO_FAILURE' as const;

export const SET_RECENT_DONE = 'SET_RECENT_DONE' as const;
export const SET_USER_SELECTED_ACCOUNT_CODE = 'SET_USER_SELECTED_ACCOUNT_CODE' as const;

export const LOAD_ACCOUNT_HISTORY_START = 'LOAD_ACCOUNT_HISTORY_START' as const;
export const LOAD_ACCOUNT_HISTORY_SUCCESS = 'LOAD_ACCOUNT_HISTORY_SUCCESS' as const;
export const LOAD_ACCOUNT_HISTORY_FAILURE = 'LOAD_ACCOUNT_HISTORY_FAILURE' as const;

export const LOAD_ACCOUNT_HISTORY_INFO_START = 'LOAD_ACCOUNT_HISTORY_INFO_START' as const;
export const LOAD_ACCOUNT_HISTORY_INFO_SUCCESS = 'LOAD_ACCOUNT_HISTORY_INFO_SUCCESS' as const;
export const LOAD_ACCOUNT_HISTORY_INFO_FAILURE = 'LOAD_ACCOUNT_HISTORY_INFO_FAILURE' as const;

export const SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE = 'SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE' as const;
export const _ROUTER_LOCATION_CHANGE = '@@router/LOCATION_CHANGE' as const;

export const SET_REQUEST_FEEDBACK = 'SET_REQUEST_FEEDBACK' as const;
export const SEND_REQUEST_FEEDBACK_START = 'SEND_REQUEST_FEEDBACK_START' as const;
export const SEND_REQUEST_FEEDBACK_SUCCESS = 'SEND_REQUEST_FEEDBACK_SUCCESS' as const;
export const SEND_REQUEST_FEEDBACK_FAILURE = 'SEND_REQUEST_FEEDBACK_FAILURE' as const;

export const UPDATE_ACCOUNT_ACTION = 'UPDATE_ACCOUNT_ACTION' as const;

export const SET_ZENDESK_CONFIG_ACTION = 'SET_ZENDESK_CONFIG_ACTION' as const;

export const DELETE_PROFILE_START = 'DELETE_PROFILE_START' as const;
export const DELETE_PROFILE_SUCCESS = 'DELETE_PROFILE_SUCCESS' as const;
export const DELETE_PROFILE_FAILURE = 'DELETE_PROFILE_FAILURE' as const;

export const UPDATE_LANG_ACTION = 'UPDATE_LANG_ACTION' as const;
export const SET_LANG_DATA_ACTION = 'SET_LANG_DATA_ACTION' as const;

export const TOGGLE_IS_ONE_CLICK_TRADING_ON = 'TOGGLE_IS_ONE_CLICK_TRADING_ON' as const;
export const SEND_FACEBOOK_EVENT_ACTION = 'SEND_FACEBOOK_EVENT_ACTION' as const;

export const COMPLETE_LEADERBOARD_ONBOARDING_SUCCESS = 'COMPLETE_LEADERBOARD_ONBOARDING_SUCCESS' as const;

export const BREAKPOINTS = {
    extraSmall: 340,
    small: 576,
    medium: 768,
    large: 1024,
    extraLarge: 1200,
    extraExtraLarge: 1440,
    xxxl: 1920,
    xxxxl: 2560,
} as const;

export const DEVICE_TYPES = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
} as const;

export const LOCALE_CODES = {
    pt: 'pt',
    id: 'id',
    en: 'en',
    hi: 'hi',
    hi_IN: 'hi',
    es: 'es_MX',
    es_MX: 'es_MX',
} as const;

export const LINKS = {
    affiliateAgreementDoc: '/app/docs/affiliate-agreement-fx.pdf',
    amlKycDoc: '/app/docs/aml-kyc.pdf',
    clientAgreementDoc: '/client_agreement',
    communicationsPolicyFxDoc: '/app/docs/communications-policy-fx.pdf',
    privacyPolicyDoc: '/privacy_policy',
    promotionsDoc: '/app/docs/promotions.pdf',
    pmDepositDoc: '/app/docs/pm-deposit.pdf',
    rulesNewLifeDoc: '/app/docs/respawn.pdf',
    loyaltyProgramDoc: '/app/docs/loyalty-program.pdf',
} as const;

export const EXTERNAL_LINKS = {
    tradingView: 'https://www.tradingview.com/',
} as const;

export const PASSWORD_CHECK_PARAMS = {
    letters: 'letters' as const,
    number: 'number' as const,
};

export type IPasswordCheckParams = typeof PASSWORD_CHECK_PARAMS.letters | typeof PASSWORD_CHECK_PARAMS.number

export const PASSWORD_COMPLEXITY_CHECK_REGEXP = {
    [PASSWORD_CHECK_PARAMS.letters]: '(?=.*[a-zA-Z\u00C0-\u00ff])' as const,
    [PASSWORD_CHECK_PARAMS.number]: '(?=.*[0-9])' as const,
};

export const RouterPaths = {
    app: '/app',
    autoLogin: '/auto-login',
    brokenLink: '/broken-link',
    cashier: '/cashier',
    confirm: '/confirm',
    contacts: '/contacts',
    createdAccounts: '/created-accounts',
    deleteProfile: '/delete-profile',
    forgot: '/forgot',
    liteTrade: '/lite-trade/:asset?',
    liteTradeChart: '/lite-trade/chart/:asset?',
    liteTradeLogin: '/lite-trade/login',
    liteTradeOrder: '/lite-trade/order',
    liteTradePortfolio: '/lite-trade/portfolio',
    liteTradePosition: '/lite-trade/position',
    liteTradeWatchlist: '/lite-trade/watchlist',
    login: '/login',
    main: '/',
    mainRedesign: '/redesign',
    mobileAppLinks: '/mobile-app-links',
    mobileBonus: '/mobile-bonus',
    mobileDepositBonus: '/mobile-bonus/deposit',
    mobileInProgress: '/mobile-in-progress',
    onboarding: '/onboarding/:attempt(initial|repeated)',
    onboardingCongratulations: '/onboarding/:attempt(initial|repeated)/congratulations',
    onboardingTutorial: '/onboarding/:attempt(initial|repeated)/tutorial/:step?',
    onboardingWelcome: '/onboarding/initial/welcome',
    partner: '/affiliate',
    partnerApiDocs: '/affiliate/api-docs/:method?',
    partnerCampaigns: '/affiliate/campaigns',
    partnerPayment: '/affiliate/payment',
    partnerPublicDocs: '/docs-affiliate-program',
    partnerStats: '/affiliate/stats',
    partnerSupport: '/affiliate/support',
    privacyPolicy: '/privacy-policy',
    promo: '/promo',
    promotions: '/promotions',
    registration: '/registration',
    reset: '/reset',
    respawn: '/respawn',
    support: '/support',
    verify: '/verify',
} as const;

export const LOG_EVENT_TYPES = {
    action: 'action',
    BANNER: 'banner',
    exception: 'exception',
    modal: 'modal',
    page: 'page',
    slider: 'slider',
    PING: 'ping',
    WSS_CONNECTION: 'wss_connection',
} as const;

export const LOG_AF_EVENT_NAMES = {
    APP_TAB_CLICK: 'app.tab_click',
    ASSET_CHART_FULLSCREEN: 'asset.chart_fullscreen',
    ASSET_CHART_TYPE: 'asset.chart_type',
    ASSET_INDICATOR: 'asset.indicator',
    ASSET_INDICATORS_LIST: 'asset.indicators_list',
    ASSET_OPEN: 'asset.open',
    ASSET_ORDER: 'asset.order',
    ASSET_ORDER_CLOSE: 'asset.order_close',
    ASSET_POSITION: 'asset.position',
    ASSET_POSITION_CLOSE: 'asset.position_close',
    ASSET_SIDE: 'asset.side',
    ASSET_TAB: 'asset.tab',
    ASSET_TAB_CLOSE: 'asset.tab_close',
    ASSET_TAB_OPEN: 'asset.tab_open',
    ASSET_TIMEFRAME: 'asset.timeframe',
    BANNER_CLICK: '{{location}}.click.banner_{{name}}',
    CASHIER_PIX_KEY_COPY: 'cashier.pix_key_copy',
    CASHIER_PROMOCODE_MODAL: 'cashier.promocode_modal',
    COLOR_THEME_CHANGE: 'color_theme.change',
    LOGIN_COMPLETED: 'login.completed',
    LOGIN_CONFIRM_PIN: 'login.confirm_pin',
    LOGIN_CREATE_PIN: 'login.create_pin',
    LOGIN_ERROR: 'login.error',
    LOGIN_FINGERPRINT: 'login.fingerprint',
    LOGIN_FINGERPRINT_SHOWN: 'login.fingerprint_shown',
    LOGIN_PIN_SHOWN: 'login.pin_shown',
    LOGIN_SET_FINGERPRINT: 'login.set_fingerprint',
    LOGIN_SHOWN: 'login.shown',
    MAIN_ACCOUNT_ANALYTICS: 'main.account_analytics',
    MAIN_ACCOUNT_OPTIONS: 'main.account_options',
    MAIN_ACCOUNT_TYPE: 'main.account_type',
    MAIN_CHANGE_TIME_FRAME: 'main.change_time_frame',
    MAIN_DEPOSIT: 'main.deposit',
    MAIN_ORDER: 'main.order',
    MAIN_POSITION: 'main.position',
    MAIN_RECOMMENDED_BANNER: 'main.recommended_banner',
    MAIN_RESPAWN: 'main.respawn',
    MAIN_RESPAWN_BANNER: 'main.respawn_banner',
    MAIN_SEARCH: 'main.search',
    MAIN_SELECT_ACCOUNT: 'main.select_account',
    MAIN_SELECT_ASSET: 'main.select_asset',
    MAIN_SHOWN: 'main.shown',
    MAIN_TAB_OPEN: 'main.tab_open',
    MAIN_TRANSACTIONS: 'main.transactions',
    MAIN_WITHDRAW: 'main.withdraw',
    MARKET_ASSET_CLICK: 'market.asset.click',
    MARKET_COLLECTION_CLICK: 'market.collection.click',
    MARKET_COLLECTION_OPEN: 'market.collection.open',
    MARKET_COLLECTION_SETTINGS: 'market.collection_settings',
    MARKET_OPEN: 'market.open',
    MINI_ONBOARDING_CHANGE_STEP: 'mini_onboarding.change_step',
    MINI_ONBOARDING_INVITATION: 'mini_onboarding.invitation',
    ORDER_ACCOUNT_CHANGED: 'order.account_changed',
    ORDER_ACTION: 'order.action',
    ORDER_AMOUNT_TYPE: 'order.amount_type',
    ORDER_CLOSE: 'order.close',
    ORDER_ERROR: 'order.error',
    ORDER_PRESET: 'order.preset',
    ORDER_SHOWN: 'order.shown',
    ORDER_SIDE: 'order.side',
    ORDER_STOP_LOSS: 'order.stop_loss',
    ORDER_TAKE_PROFIT: 'order.take_profit',
    ORDER_TYPE: 'order.type',
    PAYMENT_OPEN: 'payment.open',
    PROFILE_RESPAWN_BANNER: 'profile.respawn_banner',
    PWA_INSTALL: 'pwa_install',
    PWA_OPEN: 'pwa_open',
    PWA_OPEN_FIRST: 'pwa_open_first',
    PWA_PROMPT: 'pwa_prompt',
    SEARCH_CLOSE: 'search.close',
    SEARCH_OPEN: 'search.open',
    SEARCH_SELECT_ASSET: 'search.select_asset',
    SIGN_UP_ALREADY_HAVE_ACCOUNT: 'sign_up.already_have_account',
    SIGN_UP_COMPLETED: 'sign_up.completed',
    SIGN_UP_EMAIL_IS_CORRECT: 'sign_up.email_is_correct',
    SIGN_UP_EMAIL_IS_CORRECT_CANCEL: 'sign_up.email_is_correct_cancel',
    SIGN_UP_ERROR: 'sign_up.error',
    SIGN_UP_FORM_FILLED: 'sign_up.form_filled',
    SIGN_UP_SHOWN: 'sign_up.shown',
    SIGN_UP_STARTED: 'sign_up.started',
    TRADING_TABLE_HISTORY_TAB: 'trading_table.history_tab',
    TRADING_TABLE_ORDERS_TAB: 'trading_table.orders_tab',
    TRADING_TABLE_POSITIONS_TAB: 'trading_table.positions_tab',
    CASHIER_PRESET_CLICK: 'cashier.preset.click',
    CASHIER_PLUS_CLICK: 'cashier.pus.click',
    CASHIER_MINUS_CLICK: 'cashier.minus.click',
    CASHIER_CURRENCY_CHANGE: 'cashier.currency.change',
} as const;

export const KEY_CODES = {
    ARROW_UP: 38,
    ARROW_DOWN: 38,
    BACKSPACE: 8,
    ENTER: 13,
};


export const FEATURES = {
    ACADEMY: 'academy',
    ACHIEVEMENTS: 'achievements',
    ALERTS: 'alerts',
    ASSET_SLIDE_WITH_EXPANDED_GRAPH: 'asset_slide_with_expanded_graph',
    BANNERS: 'banners',
    BEGINNERS_GUIDE: 'beginners_guide',
    CASHBACK: 'cashback',
    CASHIER_AMOUNT_FIELD_PLUS_MINUS_REDESIGN: 'cashier_amount_field_plus_minus_redesign',
    COLOR_THEME: 'color_theme',
    COMMUNITY_LINKS: 'community_links',
    CREATE_ORDER_2: 'create_order_2',
    DEMO_LIMITS: 'demo_limits',
    DEMO_MODE: 'demo_mode',
    DEPOSIT_CURRENCY_NOTIONAL: 'deposit_currency_notional',
    DEPOSIT_ONBOARDING: 'deposit_onboarding',
    DESKTOP: 'desktop',
    HINTS: 'hints',
    LITE_TRADE: 'lite_trade',
    LEADERBOARD: 'leaderboard',
    LOGIN_WITH_GOOGLE: 'login_with_google',
    MARKET: 'market',
    MOBILE_ACCOUNT_BOX_CONTENT_REDESIGN: 'mobile_account_box_content_redesign',
    MOBILE_APP_BANNER: 'mobile_app_banner',
    MOBILE_ONBOARDING: 'mobile_onboarding',
    NEW_LIFE: 'new_life',
    NOTIFICATIONS: 'notifications',
    ONBOARDING_CHOOSE_ACCOUNT_TYPE: 'onboarding_choose_account_type',
    PROMOCODES: 'promocodes',
    REFERRAL: 'referral',
    REGISTER_FIELD_PHONE: 'register_field_phone',
    REGISTER_WITHOUT_VERIFY: 'register_without_verify',
    REQUEST_FEEDBACK: 'request_feedback',
    REQUEST_FEEDBACK_APPSTORE: 'request_feedback_appstore',
    SENTIMENT: 'sentiment',
    STATISTICS_GRAPHS_VIEW: 'statistics_graphs_view',
    SUMSUB: 'sumsub',
    SUPPORT: 'support',
    TELEGRAM: 'telegram',
    TRADING_VIEW: 'trading_view',
    TUTORIALS: 'tutorials',
    USER_STATUSES: 'user_statuses',
} as const;

export const ACCOUNT_TYPES = {
    DEMO: 'demo' as const,
    LIVE: 'live' as const,
};

export const URL_SEARCH_PARAMS = {
    ACCEPT_POLICY: 'accept-policy' as const,
    COUNTRY: 'country' as const,
    CODE: 'code' as const,
    EMAIL: 'email' as const,
    INITIAL_AMOUNT: 'initial-amount' as const,
    INITIAL_APPLY_BONUS: 'initial-apply-bonus' as const,
    INITIAL_OPEN_BONUS_TERMS: 'initial-open-bonus-terms' as const,
    PHONE: 'phone' as const,
};

export const CURRENCY_USD = 'USD' as const;

export const LOCAL_STORAGE_KEYS = {
    BEGINNERS_GUIDE_STEP_INDEX: 'beginners_guide_step_index',
    BEGINNERS_GUIDE_OPERATION_SIDE: 'beginners_guide_operation_side',
    PORTFOLIO_POSITIONS_PL_SEEN: 'portfolio_positions_pl_seen',
    PWA_OPENED_AT: 'pwa_opened_at',
    SHOWED_UPDATED_USER_STATUS_PROGRESS: 'showed_updated_user_status_progress',
    TRADE_PAGE_FOOTER_COLLAPSED: 'trade_page_footer_collapsed',
    TRADE_PAGE_FOOTER_HEIGHT: 'trade_page_footer_height',
} as const;

export const BANNER_NAMES = {
    EASTER: 'easter',
} as const;
